<script>
import { dashboardComputed, dashboardMethods } from '@state/helpers/dashboard'
import cloneDeep from 'lodash/cloneDeep'
import padStart from 'lodash/padStart'
import { DATE_TIME_FORMAT, TIME_SELECT } from '@utils/constant'
import formatDate from '@utils/format-date'
import coverChartData from '@utils/coverChartData'
import chartDateListRangeType from '@utils/chartDateListRangeType'
import tableFields from './tableFields'
import configChart from './configChart'

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: 'The Dashboard page.' }],
  },
  data() {
    return {
      items: {},
      fields: tableFields,
      src: '',
      range_member: '1',
      range_device: '1',
      TIME_SELECT: TIME_SELECT,
      configMemberChart: {
        label: '昨日までの推移',
        config: cloneDeep(configChart[1]),
      },
      configDeviceChart: {
        label: '昨日までの推移',
        config: cloneDeep(configChart[0]),
      },
      configNotificationChart: {
        label: '先月までの推移',
        config: cloneDeep(configChart[2]),
      },
    }
  },
  computed: {
    ...dashboardComputed,
    lastMeasureData() {
      const list =
        cloneDeep(this.getLastMeasure?.data)?.map((item) => {
          if (item.photo) {
            item.photo = `${process.env.VUE_APP_API_BASE_URL}/${item.photo}`
          }
          item.compare_weight =
            parseFloat(item.compare_weight).toFixed(2) + 'kg'
          item.compare_BodyFatRate =
            parseFloat(item.compare_BodyFatRate).toFixed(1) + '%'
          item.weight_at = formatDate(
            new Date(item.weight_at * 1000),
            DATE_TIME_FORMAT
          )
          item.compare_at = formatDate(
            new Date(item.compare_at * 1000),
            DATE_TIME_FORMAT
          )
          return item
        }) || []
      return list
    },
    listDeliveryComputed() {
      const list =
        cloneDeep(this.getListDelivery?.list)
          ?.splice(0, 12)
          .map((item) => {
            if (item.image_url) {
              item.image_url = `${process.env.VUE_APP_API_BASE_URL}/${item.image_url}`
            }
            return item
          }) || {}
      return list
    },
    countDeliveryComputed() {
      if (this.getListDelivery) {
        return this.getListDelivery.count
      } else {
        return ''
      }
    },
    countMemberChart() {
      if (this.getMemberChart) {
        return this.getMemberChart.member_count
      } else {
        return ''
      }
    },
    countDeviceChart() {
      if (this.getDeviceChart) {
        return this.getDeviceChart.usage
      } else {
        return ''
      }
    },
    countNotificationChart() {
      if (this.getNotificationChart) {
        return this.getNotificationChart.this_month_count
      } else {
        return ''
      }
    },
    memberChartDataComputed() {
      return this.handleGetMemberChartData()
    },
    deviceChartDataComputed() {
      return this.handleGetDeviceChartData()
    },
    notificationChartDataComputed() {
      return this.handleGetNotificationChartData()
    },
    loadingComputed() {
      return this.loading
    },
    currentId() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.agent.id
    },
  },
  created() {
    this.fetchMemberChart()
    this.fetchDeviceChart()
    this.fetchNotificationChart()
    this.fetchListDelivery()
    this.fetchLastMeasure()
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: { agent_code: user?.agent?.agent_code },
      })
      .catch(() => {})
  },
  methods: {
    ...dashboardMethods,
    fetchLastMeasure() {
      this.fetchingLastMeasure()
    },
    handleGetMemberChartData() {
      this.configMemberChart.config.data.labels = chartDateListRangeType(
        parseInt(this.range_member),
        this.getMemberChart?.data_start,
        this.getMemberChart?.data_end
      )
      const data = cloneDeep(this.getMemberChart?.data)?.map((v) => {
        return {
          x: v.label,
          y: v.value,
        }
      })
      this.configMemberChart.config.data.datasets[0].data = coverChartData(
        data,
        this.configMemberChart.config.data.labels
      )
      this.configMemberChart.config.options.scales.xAxes[0].time.unit = 'day'
      this.configMemberChart.config.options.scales.xAxes[0].ticks.source =
        'labels'
      if (this.range_member === this.TIME_SELECT.week) {
        this.configMemberChart.config.options.scales.xAxes[0].ticks.source =
          'labels'
      } else if (this.range_member === this.TIME_SELECT.month) {
        this.configMemberChart.config.options.scales.xAxes[0].ticks.source =
          'labels'
        this.configMemberChart.config.options.scales.xAxes[0].time.unit =
          'month'
      }
      return this.configMemberChart
    },
    handleGetDeviceChartData() {
      if (this.range_device === this.TIME_SELECT.week) {
        const dataStart = this.changeDate(this.getDeviceChart?.data_start)
        const deviceChart = { ...this.getDeviceChart, data_start: dataStart }
        this.configDeviceChart.config.data.labels = chartDateListRangeType(
          parseInt(this.range_device),
          deviceChart?.data_start,
          deviceChart?.data_end
        )
      } else {
        this.configDeviceChart.config.data.labels = chartDateListRangeType(
          parseInt(this.range_device),
          this.getDeviceChart?.data_start,
          this.getDeviceChart?.data_end
        )
      }
      const data = cloneDeep(this.getDeviceChart?.data)?.map((v) => {
        return {
          x: v.label,
          y: v.value,
        }
      })
      this.configDeviceChart.config.data.datasets[0].data = coverChartData(
        data,
        this.configDeviceChart.config.data.labels
      )
      this.configDeviceChart.config.options.scales.xAxes[0].time.unit = 'day'
      this.configDeviceChart.config.options.scales.xAxes[0].ticks.source =
        'labels'
      if (this.range_device === this.TIME_SELECT.week) {
        this.configDeviceChart.config.options.scales.xAxes[0].ticks.source =
          'labels'
      } else if (this.range_device === this.TIME_SELECT.month) {
        this.configDeviceChart.config.options.scales.xAxes[0].ticks.source =
          'labels'
        this.configDeviceChart.config.options.scales.xAxes[0].time.unit =
          'month'
      }
      return this.configDeviceChart
    },
    handleGetNotificationChartData() {
      this.configNotificationChart.config.data.labels = chartDateListRangeType(
        (this.range_type = 3),
        this.getNotificationChart?.data_start,
        this.getNotificationChart?.data_end
      )
      const data = cloneDeep(this.getNotificationChart?.data)?.map((v) => {
        return {
          x: v.label,
          y: v.value,
        }
      })
      this.configNotificationChart.config.data.datasets[0].data = coverChartData(
        data,
        this.configNotificationChart.config.data.labels
      )
      this.configNotificationChart.config.options.scales.xAxes[0].ticks.source =
        'labels'
      this.configNotificationChart.config.options.scales.xAxes[0].time.unit =
        'month'
      return this.configNotificationChart
    },
    switchTypeMemberChart(type) {
      this.range_member = type
      this.fetchMemberChart()
    },
    switchTypeDeviceChart(type) {
      this.range_device = type
      this.fetchDeviceChart()
    },
    viewDetail(id) {
      this.$router.push({
        path: `/panel/member-list-agent-admin/${id}/${this.currentId}`,
      })
    },
    changeDate(date) {
      var _date = new Date(date)
      var tmpStartDate = new Date(_date.getTime() + 6 * 24 * 60 * 60 * 1000)
      var _month = tmpStartDate.getMonth() + 1
      var _date1 = tmpStartDate.getDate()
      return (
        tmpStartDate.getFullYear() +
        '-' +
        padStart(_month, 2, '0') +
        '-' +
        padStart(_date1, 2, '0')
      )
    },
    fetchListDelivery() {
      const payload = {
        agent_id: this.currentId,
        status: [0, 1],
        order_by: 'schedule_start-',
      }
      this.fetchingListDelivery(payload)
    },
    fetchMemberChart() {
      const payload = { range_type: parseInt(this.range_member) }
      this.fetchingMemberChart(payload)
    },
    fetchDeviceChart() {
      const payload = { range_type: parseInt(this.range_device) }
      this.fetchingDeviceChart(payload)
    },
    fetchNotificationChart() {
      this.fetchingNotificationChart()
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="chart-member col-md-6 col-xl-4">
        <BaseCardDetail title="ただ今の登録ユーザー数" form-collapsed>
          <template v-slot:header-action>
            <span class="chart-count">{{ countMemberChart }} 人</span>
          </template>
          <template>
            <div class="chart-member-bg">
              <div class="d-flex justify-content-between align-items-center">
                <span class="ml-4">{{ memberChartDataComputed.label }}</span>
                <CDropdown placement="bottom-end" caret>
                  <template v-slot:toggler>
                    <CButton>
                      <CIcon name="cilSettings" class="c-white" />
                    </CButton>
                  </template>
                  <CDropdownItem
                    class="border-bottom"
                    @click="switchTypeMemberChart(TIME_SELECT.day)"
                    >日</CDropdownItem
                  >
                  <CDropdownItem
                    class="border-bottom"
                    @click="switchTypeMemberChart(TIME_SELECT.week)"
                    >週</CDropdownItem
                  >
                  <CDropdownItem
                    @click="switchTypeMemberChart(TIME_SELECT.month)"
                    >月</CDropdownItem
                  >
                </CDropdown>
              </div>
              <CChartBar
                style="height:200px"
                :labels="memberChartDataComputed.config.data.labels"
                :datasets="memberChartDataComputed.config.data.datasets"
                :options="memberChartDataComputed.config.options"
                class="pb-2"
              />
            </div>
          </template>
        </BaseCardDetail>
      </div>
      <div class="chart-device col-md-6 col-xl-4">
        <BaseCardDetail title="本日のデバイス活用率" form-collapsed>
          <template v-slot:header-action>
            <span class="chart-count">{{ countDeviceChart }} %</span>
          </template>
          <template>
            <div class="chart-device-bg">
              <div class="d-flex justify-content-between align-items-center">
                <span class="ml-4">{{ deviceChartDataComputed.label }}</span>
                <CDropdown placement="bottom-end" caret>
                  <template v-slot:toggler>
                    <CButton>
                      <CIcon name="cilSettings" class="c-white" />
                    </CButton>
                  </template>
                  <CDropdownItem
                    class="border-bottom"
                    @click="switchTypeDeviceChart(TIME_SELECT.day)"
                    >日</CDropdownItem
                  >
                  <CDropdownItem
                    class="border-bottom"
                    @click="switchTypeDeviceChart(TIME_SELECT.week)"
                    >週</CDropdownItem
                  >
                  <CDropdownItem
                    @click="switchTypeDeviceChart(TIME_SELECT.month)"
                    >月</CDropdownItem
                  >
                </CDropdown>
              </div>
              <CChartLine
                style="height:200px"
                :labels="deviceChartDataComputed.config.data.labels"
                :datasets="deviceChartDataComputed.config.data.datasets"
                :options="deviceChartDataComputed.config.options"
                class="pb-2"
              />
            </div>
          </template>
        </BaseCardDetail>
      </div>
      <div class="chart-notification col-md-6 col-xl-4">
        <BaseCardDetail title="今月のアプリお知らせ配信開始件数" form-collapsed>
          <template v-slot:header-action>
            <span class="chart-count">{{ countNotificationChart }} 件</span>
          </template>
          <template>
            <div class="chart-notification-bg">
              <div class="d-flex justify-content-between align-items-center">
                <span class="ml-4 my-2">{{
                  notificationChartDataComputed.label
                }}</span>
              </div>
              <CChartBar
                style="height:200px"
                :labels="notificationChartDataComputed.config.data.labels"
                :datasets="notificationChartDataComputed.config.data.datasets"
                :options="notificationChartDataComputed.config.options"
                class="pb-2"
              />
            </div>
          </template>
        </BaseCardDetail>
      </div>
    </div>

    <div>
      <h3 class="page-title">配信状況</h3>
      <div class="d-flex justify-content-start flex-wrap">
        <div
          v-for="(item, index) in listDeliveryComputed"
          :key="index"
          class="card-item d-flex mb-4 align-items-center"
          ><CImg :src="item.image_url" class="card-img" />
          <div class="card-content d-flex flex-column">
            <span>{{ item.schedule_start }}</span>
            <CLink :to="`/panel/notification_agentadmin/${item.id}`">
              <span class="limit-line custom-desc">{{ item.title }}</span>
            </CLink>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mb-4 mr-5">
        <span
          >全{{ countDeliveryComputed }}件中{{
            listDeliveryComputed.length
          }}件を表示</span
        >
      </div>
    </div>

    <div>
      <h3 class="page-title">最新計測</h3>
      <BaseTable
        striped
        border
        hover
        :loading="loadingComputed"
        :table-fields="fields"
        :data-tables="lastMeasureData"
        @row-clicked="(item) => viewDetail(item.member_id)"
      >
        <template v-slot:avatar="{ item }">
          <td>
            <CImg
              v-if="!item.photo && item.gender === 0"
              :src="require('@assets/images/female.png')"
              class="dashboard-avatar"
            />
            <CImg
              v-else-if="!item.photo && item.gender === 1"
              :src="require('@assets/images/male.png')"
              class="dashboard-avatar"
            />
            <CImg v-else :src="item.photo" class="dashboard-avatar" />
          </td>
        </template>
        <template v-slot:admin_note="{ item }">
          <td>
            <span class="limit-line">{{ item.admin_note }}</span>
          </td>
        </template>
        <template v-slot:account_name="{ item }">
          <td>
            {{ item.account_name }}
          </td>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dashboard-avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}
.page-title {
  padding-bottom: 0.5rem !important;
  margin-bottom: 1rem !important;
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  color: #23282c !important;
}
.card-item {
  width: calc(25% - 22.5px);
  margin-left: 30px;
  border: 1px solid #c8ced3;
  border-radius: 0.25rem;
}
@media screen and (min-width: 1200px) {
  .card-item:nth-child(4n + 1) {
    margin-left: 0;
  }
}
@media screen and (min-width: 769px) and (max-width: 1199px) {
  .card-item {
    width: calc((100% / 3) - 20px);
    margin-left: 30px;
  }
  .card-item:nth-child(3n + 1) {
    margin-left: 0;
  }
}
@media screen and (min-width: 577px) and (max-width: 768px) {
  .card-item {
    width: calc(50% - 15px);
    margin-left: 30px;
  }
  .card-item:nth-child(2n + 1) {
    margin-left: 0;
  }
}
@media screen and (max-width: 576px) {
  .card-item {
    width: 100%;
    margin-left: 0;
  }
}
.card-content {
  width: calc(100% - 100px);
  padding-top: 10px;
  padding-right: 10px;
}
.card-img {
  display: block;
  width: 100px;
  height: 88px;
  margin-right: 10px;
  border-radius: 0.25rem 0 0 0.25rem;
  object-fit: contain;
}

.member-header {
  /* background-color: #a1cb5e; */
  background-color: $primary;
}
.chart-member-bg {
  color: white;
  background-color: $table-hover-bg;
}
.chart-device-bg {
  color: white;
  background-color: #63c2de;
}
.chart-notification-bg {
  color: white;
  background-color: #cfa65f;
}
.c-white {
  color: white;

  &:hover {
    color: #000;
  }
}
::v-deep .card-body {
  padding: 0 !important;
}
::v-deep .card {
  .card-header {
    align-items: flex-start !important;
    color: white !important;
  }
  h5 {
    padding-top: 5px;
    font-size: 14px;
  }
  .chart-count {
    font-size: 25px;
    font-weight: 600;
  }
}
::v-deep .chart-member {
  .card-header {
    background-color: #a1cb5e !important;
    border: 1px solid #8bbd3d !important;
  }
  .card-body {
    border-right: 1px solid #8bbd3d !important;
    border-bottom: 1px solid #8bbd3d !important;
    border-left: 1px solid #8bbd3d !important;
  }
}
::v-deep .chart-device {
  .card-header {
    background-color: #56bddb !important;
    border: 1px solid #2eadd3 !important;
  }
  .card-body {
    border-right: 1px solid #2eadd3 !important;
    border-bottom: 1px solid #2eadd3 !important;
    border-left: 1px solid #2eadd3 !important;
  }
}
::v-deep .chart-notification {
  .card-header {
    background-color: #cb9f53 !important;
    border: 1px solid #b78837 !important;
  }
  .card-body {
    border-right: 1px solid #b78837 !important;
    border-bottom: 1px solid #b78837 !important;
    border-left: 1px solid #b78837 !important;
  }
}
.custom-desc {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
</style>
